import { render, staticRenderFns } from "./channelPage.vue?vue&type=template&id=67ed5a3c&scoped=true"
import script from "./channelPage.vue?vue&type=script&lang=js"
export * from "./channelPage.vue?vue&type=script&lang=js"
import style0 from "./channelPage.vue?vue&type=style&index=0&id=67ed5a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed5a3c",
  null
  
)

export default component.exports